import request from '@/utils/request'

const url = 'admin/customer.herdsman'
/**
 * 牧民管理接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 编辑Account
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Account
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },

  /**
   * 更改Account数据
   * @returns
   */
  ChangeStatus(data) {
    return request({
      url: `${url}/changeStatus`,
      method: 'post',
      data
    })
  }

}

export default api
